<template>
<div class="c-step step-6">
  <div>
    <stepsCounter></stepsCounter>
    <div class="c-step-ask">
      Sugerowana przez Państwa data odbioru samochodu?
      <div class="flex-row">
        <div class="flex-item">
          <datepicker v-model="answerInput.date" name="data" :format="dateFormatter" :language="pl" :full-month-name="true" :inline="true" :disabled-dates="{to:new Date()}"></datepicker>
        </div>
      </div>
      <br>&nbsp;<br>
      Sugerowane godziny, w których chcielibyście Państwo odebrać samochód?
      <div class="flex-row">
        <div class="flex-item">
          <span class="label">od godziny:</span>
          <datetime v-model="answerInput.from" type="time" minute-step="10" title="Od godziny:" :phrases="{ok: 'Wybierz', cancel: 'Anuluj'}" :min-datetime="hours.from" :max-datetime="hours.to || answerInput.to" value-zone="local"></datetime>
        </div>
        <div class="flex-item">
          <span class="label">do godziny:</span>
          <datetime v-model="answerInput.to" type="time" minute-step="10" title="Do godziny:" :phrases="{ok: 'Wybierz', cancel: 'Anuluj'}" :min-datetime="hours.from || answerInput.from" :max-datetime="hours.to" value-zone="local"></datetime>
        </div>
      </div>
    </div>
  </div>
  <div class="c-step-answers">
    <button v-if="answerInput.from && answerInput.to && answerInput.date" v-on:click="answer(answerInput)">Dalej</button>
  </div>
</div>
</template>

<script>
import {
  mapActions
} from 'vuex'
//Date
import Datepicker from 'vuejs-datepicker';
import moment from 'moment';
import {
  pl
} from 'vuejs-datepicker/dist/locale'
// TIME
import {
  Datetime
} from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css'

import stepsCounter from './../stepsCounter'

var date = new Date();

var from = new Date().setHours(9);
var to = new Date().setHours(19,59,0);
// .toISOString()
var fromISO = new  Date(from).toISOString();
var toISO = new Date(to).toISOString();

console.log(fromISO);
console.log(to);

export default {
  name: 'step6',
  data() {
    return {
      pl: pl,
      hours:{
        from:fromISO,
        to: toISO
      },
      answerInput: {
        from: null,
        to: null,
        date: null
      }
    }
  },
  methods: {
    dateFormatter(date) {
      return moment(date).format('YYYY-MM-DD HH:mm:ss');
    },
    answer(answer) {
      this.$store.dispatch('answer', {
        step: '6',
        answer: answer
      })
    }
  },
  components: {
    'stepsCounter': stepsCounter,
    'datetime': Datetime,
    Datepicker
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.label {
    padding-top: 1rem;
    display: inline-block;
}
.vdp-datepicker, .vdp-datepicker__calendar{
  margin: 0 auto;
}
</style>
